import type { TOC } from '@ember/component/template-only';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import type { Option } from '@mylighthouse/prism-ember/types/components/prism/select-input';
import GeneralDropdownsTriggersTriggerPowerSelectKebab from 'lumen/components/general/dropdowns/triggers/trigger-power-select-kebab';

export type DropdownMappingMoreActionsOptionType = Option & {
  icon?: string;
  id: string;
  label: string;
  unsafe_isLink?: boolean;
};

interface SettingsCentralMappingDropdownsDropdownMappingMoreActionsSignature {
  Args: {
    dropdownOptions: DropdownMappingMoreActionsOptionType[];
    onSelect: (value: DropdownMappingMoreActionsOptionType) => void;
  };
}

const SettingsCentralMappingDropdownsDropdownMappingMoreActions: TOC<SettingsCentralMappingDropdownsDropdownMappingMoreActionsSignature> =
  <template>
    <PrismComboSelectInput
      @horizontalPosition="right"
      @onChange={{@onSelect}}
      @options={{@dropdownOptions}}
      @unsafe_triggerComponent={{GeneralDropdownsTriggersTriggerPowerSelectKebab}}
      data-test-id="dropdown-central-mapping-more-actions"
    />
  </template>;

export default SettingsCentralMappingDropdownsDropdownMappingMoreActions;
